(function () {
  'use strict';

  if (window.AxiomProductMedia) return;

  var registeredModelIds = new Set();
  var xrFeaturePromise = null;
  var modelViewerStylesheetPromise = null;
  var modelViewerStylesheetUrl = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';

  function reducedMotion() {
    return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function loadShopifyFeature(name) {
    return new Promise(function (resolve) {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        resolve(false);
        return;
      }

      window.Shopify.loadFeatures([{
        name: name,
        version: '1.0',
        onLoad: function (errors) {
          resolve(!errors);
        }
      }]);
    });
  }

  function ensureModelViewerStylesheet() {
    if (modelViewerStylesheetPromise) return modelViewerStylesheetPromise;
    modelViewerStylesheetPromise = new Promise(function (resolve) {
      var existing = document.querySelector(
        'link[data-product-model-viewer-stylesheet], link[href="' + modelViewerStylesheetUrl + '"]'
      );
      if (existing) {
        if (existing.sheet) {
          resolve(true);
          return;
        }
        existing.addEventListener('load', function () { resolve(true); }, { once: true });
        existing.addEventListener('error', function () { resolve(false); }, { once: true });
        return;
      }

      var stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = modelViewerStylesheetUrl;
      stylesheet.dataset.productModelViewerStylesheet = '';
      stylesheet.addEventListener('load', function () { resolve(true); }, { once: true });
      stylesheet.addEventListener('error', function () { resolve(false); }, { once: true });
      document.head.appendChild(stylesheet);
    });
    return modelViewerStylesheetPromise;
  }

  function ensureXrFeature() {
    if (!xrFeaturePromise) {
      xrFeaturePromise = loadShopifyFeature('shopify-xr');
    }
    return xrFeaturePromise;
  }

  function pauseIframe(iframe) {
    if (!iframe || !iframe.contentWindow) return;
    var source = (iframe.getAttribute('src') || '').toLowerCase();
    if (source.indexOf('youtube') !== -1 || iframe.classList.contains('js-youtube')) {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'pauseVideo',
        args: ''
      }), '*');
      return;
    }
    if (source.indexOf('vimeo') !== -1 || iframe.classList.contains('js-vimeo')) {
      iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
    }
  }

  function pauseAll(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    target.querySelectorAll('video').forEach(function (video) {
      if (typeof video.pause === 'function') video.pause();
    });
    target.querySelectorAll('iframe').forEach(function (iframe) {
      if (iframe.closest('axiom-deferred-media')) return;
      pauseIframe(iframe);
    });
    target.querySelectorAll('product-model').forEach(function (productModel) {
      if (typeof productModel.pause === 'function') productModel.pause();
    });
    target.querySelectorAll('axiom-deferred-media').forEach(function (deferredMedia) {
      if (typeof deferredMedia.pause === 'function') deferredMedia.pause();
    });
  }

  function isControlTarget(target) {
    return Boolean(
      target &&
      target.closest &&
      target.closest(
        'axiom-autoplay-product-video, axiom-deferred-media, product-model, video, iframe, model-viewer, [data-product-media-poster], [data-shopify-xr]'
      )
    );
  }

  function playAutoplay(scope) {
    if (!scope || !scope.querySelector || reducedMotion()) return;
    var player = scope.matches && scope.matches('axiom-autoplay-product-video')
      ? scope
      : scope.querySelector('axiom-autoplay-product-video');
    if (player && typeof player.play === 'function') player.play();
  }

  function modelIdFromSurface(surface, requestedId) {
    if (!surface || !surface.querySelector) return '';
    if (requestedId) {
      var requested = Array.prototype.find.call(
        surface.querySelectorAll('[data-media-id][data-media-type="model"]'),
        function (item) {
          return String(item.dataset.mediaId || '') === String(requestedId);
        }
      );
      if (requested) return String(requestedId);
    }
    var firstModel = surface.querySelector('[data-media-id][data-media-type="model"]');
    return firstModel ? String(firstModel.dataset.mediaId || '') : '';
  }

  function syncXrButton(surface, mediaId) {
    if (!surface || !surface.querySelector) return;
    var button = surface.querySelector('[data-shopify-xr]');
    if (!button) return;
    var modelId = modelIdFromSurface(surface, mediaId);
    if (modelId) button.dataset.shopifyModel3dId = modelId;
    if (window.ShopifyXR && typeof window.ShopifyXR.setupXRElements === 'function') {
      window.ShopifyXR.setupXRElements();
    }
  }

  function collectModels(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    var models = [];
    target.querySelectorAll('[data-product-model-json]').forEach(function (script) {
      var parsed = [];
      try {
        parsed = JSON.parse(script.textContent || '[]');
      } catch (error) {
        parsed = [];
      }
      parsed.forEach(function (model) {
        var id = model && model.id != null ? String(model.id) : '';
        if (!id || registeredModelIds.has(id)) return;
        models.push(model);
      });
    });
    return models;
  }

  function registerModels(scope) {
    var hasXrButton = Boolean(
      scope && scope.querySelector
        ? scope.querySelector('[data-shopify-xr]')
        : document.querySelector('[data-shopify-xr]')
    );
    if (!collectModels(scope).length && !hasXrButton) return Promise.resolve();

    return ensureXrFeature().then(function (loaded) {
      if (!loaded) return;
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function handleXrReady() {
          document.removeEventListener('shopify_xr_initialized', handleXrReady);
          registerModels(document);
        });
        return;
      }
      var models = collectModels(scope);
      if (models.length && typeof window.ShopifyXR.addModels === 'function') {
        window.ShopifyXR.addModels(models);
        models.forEach(function (model) {
          registeredModelIds.add(String(model.id));
        });
      }
      if (typeof window.ShopifyXR.setupXRElements === 'function') {
        window.ShopifyXR.setupXRElements();
      }
    });
  }

  class AxiomAutoplayProductVideo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.productMediaInitialized === 'true') return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.dataset.productMediaInitialized = 'true';
      this.handleClick = this.togglePlayback.bind(this);
      this.handleKeydown = this.onKeydown.bind(this);
      this.handlePlaybackChange = this.syncState.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.video.addEventListener('play', this.handlePlaybackChange);
      this.video.addEventListener('pause', this.handlePlaybackChange);
      this.syncState();
    }

    disconnectedCallback() {
      if (this.handleClick) this.removeEventListener('click', this.handleClick);
      if (this.handleKeydown) this.removeEventListener('keydown', this.handleKeydown);
      if (this.video && this.handlePlaybackChange) {
        this.video.removeEventListener('play', this.handlePlaybackChange);
        this.video.removeEventListener('pause', this.handlePlaybackChange);
        this.video.pause();
      }
      this.dataset.productMediaInitialized = 'false';
    }

    play() {
      if (!this.video || reducedMotion()) return;
      this.video.muted = true;
      var playPromise = this.video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    pause() {
      if (this.video && typeof this.video.pause === 'function') this.video.pause();
    }

    togglePlayback() {
      if (!this.video) return;
      if (this.video.paused) {
        this.play();
      } else {
        this.pause();
      }
    }

    onKeydown(event) {
      if (event.key !== ' ' && event.key !== 'Enter') return;
      event.preventDefault();
      this.togglePlayback();
    }

    syncState() {
      if (!this.video) return;
      var playing = !this.video.paused;
      this.setAttribute('aria-pressed', String(playing));
      this.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
    }
  }

  class AxiomDeferredMedia extends HTMLElement {
    connectedCallback() {
      if (this.dataset.productMediaInitialized === 'true') return;
      this.dataset.productMediaInitialized = 'true';
      this.poster = this.querySelector('[data-product-media-poster]');
      if (!this.poster) return;
      this.handlePosterClick = this.loadContent.bind(this);
      this.poster.addEventListener('click', this.handlePosterClick);
    }

    disconnectedCallback() {
      if (this.poster && this.handlePosterClick) {
        this.poster.removeEventListener('click', this.handlePosterClick);
      }
      this.pause();
      this.dataset.productMediaInitialized = 'false';
    }

    pause() {
      if (this.dataset.mediaType === 'external_video') {
        this.querySelectorAll('iframe').forEach(function (iframe) {
          iframe.remove();
        });
        this.removeAttribute('loaded');
        return;
      }
      this.querySelectorAll('video').forEach(function (video) {
        if (typeof video.pause === 'function') video.pause();
      });
      this.querySelectorAll('iframe').forEach(pauseIframe);
      if (this.modelViewerUI && typeof this.modelViewerUI.pause === 'function') {
        this.modelViewerUI.pause();
      }
    }

    loadContent(focus) {
      pauseAll(document);
      if (this.dataset.mediaType === 'model') {
        syncXrButton(this.closest('[data-product-media-surface]'), this.dataset.mediaId);
      }
      if (this.hasAttribute('loaded')) {
        this.activateLoadedMedia();
        return;
      }

      var template = this.querySelector('template');
      if (!template || !template.content.firstElementChild) return;

      var content = document.createElement('div');
      content.appendChild(template.content.firstElementChild.cloneNode(true));
      var media = content.querySelector('video, model-viewer, iframe');
      if (!media) return;

      this.setAttribute('loaded', '');
      this.appendChild(media);
      if (focus !== false && typeof media.focus === 'function') {
        media.focus({ preventScroll: true });
      }
      if (media.matches('video') && media.hasAttribute('autoplay') && typeof media.play === 'function') {
        var playPromise = media.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
      if (media.matches('iframe')) {
        var formerStyle = media.getAttribute('style');
        media.style.display = 'block';
        window.setTimeout(function () {
          if (formerStyle == null) {
            media.removeAttribute('style');
          } else {
            media.setAttribute('style', formerStyle);
          }
        }, 0);
      }
    }

    activateLoadedMedia() {
      var media = this.querySelector('video, iframe, model-viewer');
      if (!media) return;
      if (media.matches('video') && typeof media.play === 'function') {
        var playPromise = media.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
      if (typeof media.focus === 'function') media.focus({ preventScroll: true });
    }

  }

  if (!customElements.get('axiom-autoplay-product-video')) {
    customElements.define('axiom-autoplay-product-video', AxiomAutoplayProductVideo);
  }

  if (!customElements.get('axiom-deferred-media')) {
    customElements.define('axiom-deferred-media', AxiomDeferredMedia);
  }

  if (!customElements.get('product-model')) {
    customElements.define('product-model', class ProductModel extends AxiomDeferredMedia {
      connectedCallback() {
        super.connectedCallback();
        this.prepareModel();
      }

      loadContent(focus) {
        var hadModelViewer = Boolean(this.querySelector('model-viewer'));
        super.loadContent(focus);
        if (!hadModelViewer && this.querySelector('model-viewer')) this.prepareModel();
      }

      prepareModel() {
        var modelViewer = this.querySelector('model-viewer');
        if (!modelViewer) return;

        this.setupModelUI();
        ensureModelViewerStylesheet();
        if (this.dataset.productModelFeatureLoading === 'true' || this.modelViewerUI) return;
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

        this.dataset.productModelFeatureLoading = 'true';
        window.Shopify.loadFeatures([{
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this)
        }]);
      }

      disconnectedCallback() {
        this.teardownModelUI();
        super.disconnectedCallback();
      }

      setupModelUI() {
        if (!this.hasAttribute('data-product-model-ui')) return;
        this.teardownModelUI();

        var modelViewer = this.querySelector('model-viewer');
        if (!modelViewer) return;

        this.modelUIAbortController = new AbortController();
        this.modelUIViewer = modelViewer;
        this.modelUICameraButtons = Array.prototype.slice.call(
          this.querySelectorAll('[data-product-model-camera-button]')
        );
        this.modelUIProgressBar = this.querySelector('[data-product-model-progress-bar]');
        this.modelUIStatus = this.querySelector('[data-product-model-status]');
        this.modelUIFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.modelUIReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        modelViewer.setAttribute('interaction-prompt', 'none');
        modelViewer.setAttribute('touch-action', 'pan-y');
        modelViewer.setAttribute('environment-image', 'neutral');
        modelViewer.setAttribute('exposure', this.dataset.modelExposure);
        modelViewer.setAttribute('shadow-intensity', this.dataset.modelShadowIntensity);
        modelViewer.setAttribute('shadow-softness', this.dataset.modelShadowSoftness);

        var listenerOptions = { signal: this.modelUIAbortController.signal };
        this.addEventListener('click', this.handleModelUIClick.bind(this), listenerOptions);
        modelViewer.addEventListener('pointerenter', this.handleModelUIPointerEnter.bind(this), listenerOptions);
        modelViewer.addEventListener('pointerleave', this.handleModelUIPointerLeave.bind(this), listenerOptions);
        modelViewer.addEventListener('pointermove', this.handleModelUIPointerMove.bind(this), listenerOptions);
        modelViewer.addEventListener('pointerdown', this.handleModelUIPointerDown.bind(this), listenerOptions);
        modelViewer.addEventListener('keydown', this.handleModelUIKeydown.bind(this), listenerOptions);
        modelViewer.addEventListener('camera-change', this.handleModelUICameraChange.bind(this), listenerOptions);
        modelViewer.addEventListener('progress', this.handleModelUIProgress.bind(this), listenerOptions);
        modelViewer.addEventListener('load', this.handleModelUILoad.bind(this), listenerOptions);
        window.addEventListener('pointerup', this.handleModelUIPointerUp.bind(this), listenerOptions);

        if (modelViewer.loaded) this.handleModelUILoad();
      }

      teardownModelUI() {
        if (this.modelUIAbortController) this.modelUIAbortController.abort();
        this.modelUIAbortController = null;
        this.modelUIViewer = null;
        this.modelUICameraButtons = null;
        this.modelUIProgressBar = null;
        this.modelUIStatus = null;
        this.removeAttribute('data-model-hover');
        this.removeAttribute('data-model-drag');
      }

      handleModelUIPointerEnter() {
        this.setAttribute('data-model-hover', '');
      }

      handleModelUIPointerLeave() {
        this.removeAttribute('data-model-hover');
        this.removeAttribute('data-model-drag');
      }

      handleModelUIPointerMove(event) {
        if (!this.modelUIFinePointer || !this.modelUIFinePointer.matches) return;
        var bounds = this.modelUIViewer.getBoundingClientRect();
        if (!bounds.width || !bounds.height) return;
        var x = event.clientX - bounds.left;
        var y = event.clientY - bounds.top;
        this.style.setProperty('--product-model-ui-cursor-x', x + 'px');
        this.style.setProperty('--product-model-ui-cursor-y', y + 'px');
        if (this.modelUIReducedMotion && this.modelUIReducedMotion.matches) return;
        this.style.setProperty('--product-model-ui-spot-x', (x / bounds.width * 100) + '%');
        this.style.setProperty('--product-model-ui-spot-y', (y / bounds.height * 100) + '%');
      }

      handleModelUIPointerDown() {
        this.setAttribute('data-model-drag', '');
        this.dismissInteractionHint();
      }

      handleModelUIPointerUp() {
        this.removeAttribute('data-model-drag');
      }

      handleModelUIKeydown(event) {
        if (event.key.indexOf('Arrow') === 0 || event.key === '+' || event.key === '-') {
          this.dismissInteractionHint();
        }
      }

      handleModelUIClick(event) {
        var cameraButton = event.target.closest('[data-product-model-camera-button]');
        if (cameraButton && this.contains(cameraButton)) {
          this.setModelUICamera(cameraButton.dataset.cameraOrbit, cameraButton);
          var selectedMessage = this.dataset.viewSelectedTemplate || '';
          this.announceModelUIStatus(
            selectedMessage.replace('[view]', cameraButton.dataset.cameraViewLabel || cameraButton.textContent.trim())
          );
          return;
        }

        var resetButton = event.target.closest('[data-product-model-reset]');
        if (!resetButton || !this.contains(resetButton)) return;
        var defaultOrbit = this.dataset.defaultCameraOrbit || '30deg 70deg 105%';
        this.modelUIViewer.setAttribute('camera-target', 'auto auto auto');
        this.setModelUICamera(defaultOrbit, this.modelUICameraButtons && this.modelUICameraButtons[0]);
        this.announceModelUIStatus(this.dataset.viewResetMessage || '');
      }

      setModelUICamera(cameraOrbit, activeButton) {
        if (!this.modelUIViewer || !cameraOrbit) return;
        this.modelUIViewer.setAttribute('camera-orbit', cameraOrbit);
        if (
          this.modelUIReducedMotion &&
          this.modelUIReducedMotion.matches &&
          typeof this.modelUIViewer.jumpCameraToGoal === 'function'
        ) {
          this.modelUIViewer.jumpCameraToGoal();
        }
        if (this.modelUICameraButtons) {
          this.modelUICameraButtons.forEach(function (button) {
            button.setAttribute('aria-pressed', String(button === activeButton));
          });
        }
        this.dismissInteractionHint();
      }

      handleModelUICameraChange(event) {
        if (event.detail && event.detail.source === 'user-interaction' && this.modelUICameraButtons) {
          this.modelUICameraButtons.forEach(function (button) {
            button.setAttribute('aria-pressed', 'false');
          });
        }
      }

      handleModelUIProgress(event) {
        if (!this.modelUIProgressBar) return;
        var progress = event.detail && Number(event.detail.totalProgress);
        if (!Number.isFinite(progress)) progress = 0;
        progress = Math.max(0, Math.min(1, progress));
        this.modelUIProgressBar.style.transform = 'scaleX(' + progress + ')';
        if (progress < 1) this.removeAttribute('data-model-loaded');
      }

      handleModelUILoad() {
        if (this.modelUIProgressBar) this.modelUIProgressBar.style.transform = 'scaleX(1)';
        this.setAttribute('data-model-loaded', '');
      }

      announceModelUIStatus(message) {
        if (!message || !this.modelUIStatus) return;
        this.modelUIStatus.textContent = '';
        window.requestAnimationFrame(function () {
          if (this.modelUIStatus) this.modelUIStatus.textContent = message;
        }.bind(this));
      }

      dismissInteractionHint() {
        this.setAttribute('data-model-interacted', '');
      }

      setupModelViewerUI(errors) {
        delete this.dataset.productModelFeatureLoading;
        var modelViewer = this.querySelector('model-viewer');
        if (errors || !modelViewer || !window.Shopify.ModelViewerUI) return;
        this.modelViewerUI = new window.Shopify.ModelViewerUI(modelViewer);
        this.mountModelUIOverlay(modelViewer.closest('.shopify-model-viewer-ui'));
      }

      mountModelUIOverlay(modelViewerWrapper) {
        if (!this.hasAttribute('data-product-model-ui') || !modelViewerWrapper) return;
        this.querySelectorAll('[data-product-model-ui-overlay]').forEach(function (element) {
          modelViewerWrapper.appendChild(element);
        });
      }
    });
  }

  window.AxiomProductMedia = {
    isControlTarget: isControlTarget,
    initialize: initialize,
    pauseAll: pauseAll,
    playAutoplay: playAutoplay,
    registerModels: registerModels,
    syncXrButton: syncXrButton
  };

  function initialize(scope) {
    registerModels(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    pauseAll(event.target);
  });
})();
